export default {
  path: 'notification',
  component: () => import('@/views/Route'),
  children: [
    {
      path: '',
      name: 'Notifications',
      component: () => import('@/views/menus/notificationList/Index'),
      meta: {
        permission: true
      }
    }
  ]
}
